import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DataColumnsHintFooter = () => {
  return /*#__PURE__*/_jsx(Text, {
    margin: "0",
    padding: "0",
    as: "p",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "report-customization-components.customization-components.sharedLabels.dataColumns.addPropertiesHint"
    })
  });
};
export default DataColumnsHintFooter;